export default {
  mainHeading: 'Features',
  grid: [
    {
      image: 'free',
      headingRed: '100% Free',
      description:
        'Sign up and create your account for free. Have access to a video library of your own and access all your past recordings anytime.',
    },
    {
      image: 'quality',
      headingRed: 'Quality',
      description:
        'Record as and when you want. Use the online video trimmer to customize your recordings',
    },
    {
      image: 'customise',
      headingRed: 'Customize',
      description:
        'Record at 1080p or a set a resolution of your choice. Our videos download as .webm the hottest and web optimized video format with a very small file size',
    },
  ],
};
